import { Component, EventEmitter, Input, Output } from "@angular/core"
import ResourceUtils from "../../../utils/resource-utils"
import { CHNode } from "../../../models/node.model"

@Component({
    selector: "app-subjects-dropdown",
    templateUrl: "./subjects-dropdown.component.html",
    styleUrls: ["./subjects-dropdown.component.scss"],
})
export class SubjectsDropdownComponent {
    @Input()
    subjects: CHNode[] = []

    @Output()
    subjectSelected = new EventEmitter<string[]>()

    @Output()
    toggleSubjectPanel = new EventEmitter<string>()

    getSubjectColor = ResourceUtils.getSubjectColor
    isSubjectsPanelOpened = false

    onSubjectSelected(url): void {
        this.isSubjectsPanelOpened = false
        this.subjectSelected.emit(url)
    }

    toggleSubjectsPanel() {
        this.isSubjectsPanelOpened = !this.isSubjectsPanelOpened
        this.toggleSubjectPanel.emit("subject")
    }

    getAvailableSubjects(discipline) {
        return discipline.children.filter((node) => node.resultsCount > 0)
    }
}
